module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "layout-breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("系统管理")])]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("角色管理")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-content-main"
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 80
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "角色名称",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "角色名称"
    },
    model: {
      value: (_vm.formValidate.name),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "name", $$v)
      },
      expression: "formValidate.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "备注"
    },
    model: {
      value: (_vm.formValidate.info),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "info", $$v)
      },
      expression: "formValidate.info"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "roleAddContent"
  }, [_c('div', {
    staticClass: "roleAddLeft"
  }, [_c('div', {
    staticClass: "roleAddTitle"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-paper"
    }
  }), _vm._v("\n            功能权限\n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "roleTreeContent"
  }, [_c('tree-menu', {
    attrs: {
      "deptData": _vm.MenuLists,
      "selectedId": _vm.selectedMenu
    },
    on: {
      "getMenusTree": _vm.getMenusTree
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "roleAddRight"
  }, [_c('div', {
    staticClass: "roleAddTitle"
  }, [_c('Icon', {
    attrs: {
      "type": "soup-can"
    }
  }), _vm._v("\n            数据权限\n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "roleTreeContent"
  }, [_c('tree-com', {
    attrs: {
      "deptData": _vm.deptLists,
      "selectedId": _vm.selectedDept
    },
    on: {
      "getTree": _vm.getDeptNodes
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "butBox"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Role'
        })
      }
    }
  }, [_vm._v("返回")])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6653b822!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SystemManage/roleAdd.vue
// module id = 921
// module chunks = 1